import { makeStyles } from "@material-ui/core";

const drawerWidth = 310;

const useStyles = makeStyles(theme => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        position: 'relative',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(9) + 1,
        // [theme.breakpoints.up('sm')]: {
        //     width: theme.spacing(9) + 1,
        // },
    },
    arrow: {
        position: "absolute",
        top: '50px',
        left: drawerWidth,
        cursor: 'pointer',
        backgroundColor: '#fff',
        border: '1px solid #cabfbf',
        display: 'flex',
        borderRadius: '50px',
        zIndex: 1201
    },
    arrowOpen: {
        left: drawerWidth - theme.spacing(2),
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    arrowClose: {
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        left: theme.spacing(8) - 4,
        // [theme.breakpoints.up('sm')]: {
        //     left: theme.spacing(8) - 4,
        // },
    },
    drawerContentContainer: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    drawerOption: {
        color: '#fff',
        cursor: 'pointer'
    },
    drawerOptionSelected: {
        color: '#F7C01D',
        backgroundColor: '#5A6293',
        borderLeft: '3px solid #f7c01d'

    },
    nested: {
        paddingLeft: theme.spacing(5),
    },
}));

export default useStyles;